var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictureAsPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.1668 5.91667H23.6667C20.4126 5.91667 17.7501 8.57917 17.7501 11.8333V47.3333C17.7501 50.5875 20.4126 53.25 23.6667 53.25H59.1668C62.4209 53.25 65.0834 50.5875 65.0834 47.3333V11.8333C65.0834 8.57917 62.4209 5.91667 59.1668 5.91667ZM59.1668 47.3333H23.6667V11.8333H59.1668V47.3333ZM11.8334 17.75H5.91675V59.1667C5.91675 62.4208 8.57925 65.0833 11.8334 65.0833H53.2501V59.1667H11.8334V17.75ZM47.3334 35.5V26.625C47.3334 24.9979 46.0022 23.6667 44.3751 23.6667H38.4584V38.4583H44.3751C46.0022 38.4583 47.3334 37.1271 47.3334 35.5ZM41.4167 26.625H44.3751V35.5H41.4167V26.625ZM53.2501 32.5417H56.2084V29.5833H53.2501V26.625H56.2084V23.6667H50.2918V38.4583H53.2501V32.5417ZM29.5834 32.5417H32.5417C34.1688 32.5417 35.5001 31.2104 35.5001 29.5833V26.625C35.5001 24.9979 34.1688 23.6667 32.5417 23.6667H26.6251V38.4583H29.5834V32.5417ZM29.5834 26.625H32.5417V29.5833H29.5834V26.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureAsPdf);
export default __webpack_public_path__ + "static/media/picture_as_pdf.516746ba88d395d539d8f702ca97b4e2.svg";
export { ForwardRef as ReactComponent };